(function () {
  function parseNumber(value) {
    if (!value) return NaN;
    var normalized = String(value).trim().replace(',', '.');
    var num = parseFloat(normalized);
    return Number.isFinite(num) ? num : NaN;
  }

  function normalizeHeight(value) {
    var height = parseNumber(value);
    if (!Number.isFinite(height) || height <= 0) return NaN;
    if (height < 3) height = height * 100;
    return height;
  }

  function normalizeWeight(value) {
    var weight = parseNumber(value);
    if (!Number.isFinite(weight) || weight <= 0) return NaN;
    return weight;
  }

  function suggestSize(heightCm, weightKg) {
    var score = heightCm * 0.55 + weightKg * 0.45;
    if (score < 118) return 'P';
    if (score < 128) return 'M';
    if (score < 138) return 'G';
    return 'GG';
  }

  function initPanel(root) {
    if (!root || root.dataset.sizeGuideReady === 'true') return;
    root.dataset.sizeGuideReady = 'true';

    var heightInput = root.querySelector('[data-size-guide-height]');
    var weightInput = root.querySelector('[data-size-guide-weight]');
    var submitBtn = root.querySelector('[data-size-guide-submit]');
    var resultEl = root.querySelector('[data-size-guide-result]');
    if (!heightInput || !weightInput || !submitBtn || !resultEl) return;

    function updateButtonState() {
      var height = normalizeHeight(heightInput.value);
      var weight = normalizeWeight(weightInput.value);
      var ready = Number.isFinite(height) && Number.isFinite(weight);
      submitBtn.disabled = !ready;
      submitBtn.textContent = ready
        ? 'Ver sugestão de tamanho'
        : 'Preencha sua altura e peso para ver a sugestão.';
    }

    function showSuggestion() {
      var height = normalizeHeight(heightInput.value);
      var weight = normalizeWeight(weightInput.value);
      if (!Number.isFinite(height) || !Number.isFinite(weight)) {
        resultEl.hidden = true;
        updateButtonState();
        return;
      }

      var size = suggestSize(height, weight);
      resultEl.hidden = false;
      resultEl.textContent = 'Sugestão de tamanho: ' + size + '.';
    }

    heightInput.addEventListener('input', function () {
      resultEl.hidden = true;
      updateButtonState();
    });
    weightInput.addEventListener('input', function () {
      resultEl.hidden = true;
      updateButtonState();
    });
    submitBtn.addEventListener('click', showSuggestion);

    updateButtonState();
  }

  function initAll() {
    document.querySelectorAll('[data-size-guide]').forEach(initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
